import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

export const useCookieRedirect = (wantedStudyId: string) => {
    const [cookies, setCookie] = useCookies(['WpCurrentStudy']);
    const navigate = useNavigate();

    if (wantedStudyId !== cookies.WpCurrentStudy) {
        setCookie("WpCurrentStudy", wantedStudyId, { path: "/", expires: new Date(9999, 12, 31) });
        navigate(0);
    }
}
